import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './pages/layout/Layout';
import PricingPage from './pages/pricing/PricingPage';
import PassConfirmation from './pages/employee-password-confirmation/PassConfirmation';
import EmailSent from './pages/email-sent/EmailSent';
import ProcessSuccess from './pages/process-success/ProcessSucess';
import Confirmation from './pages/confirmation/Confirmation';
import { ROUTES } from './common/constants/routes';
import { ClerkSignedOut } from './common/clerk-components/index';
import PlanConfirmation from './pages/pricing/PlanConfirmation';
import { CompanyCreate } from './pages/company-create/CompanyCreate';
import SettingsPage from './pages/settings/SettingsPage';
import { NoCompanyHandler } from './pages/company-create/components/routes/NoCompanyHandler';
import { NoCompanyRedirect } from './common/no-company-redirect/NoCompanyRedirect';
import { RolesGateRedirect } from './common/roles-gate';
import { GROUPS } from './common/constants/groups';
import { useUserInfo } from './common/hooks/useUserInfo';
import DocumentVault from './pages/document-vault/DocumentVault';
import SigningPage from './pages/signing';
import DocumentsPage from './pages/documents';
import PageNotFound from './pages/page-not-found';
import ProtectedRoute from './common/roles-gate/protected-route';
import BusinessProfile from './pages/business-profile/BusinessProfile';
import EmployeeProfilesV2 from './pages/employee-profiles/EmployeeProfilesV2';
import EmployeeProfileV2 from './pages/employee-profiles/EmployeeProfileV2';
import { useCountriesInfo } from './common/hooks/useCountries';
import SupplierProfilesV2 from './pages/supplier-profiles/SupplierProfilesV2';
import SupplierProfileV2 from './pages/supplier-profiles/SupplierProfileV2';
import CustomerProfilesV2 from './pages/customer-profiles/CustomerProfilesV2';
import CustomerProfileV2 from './pages/customer-profiles/CustomerProfileV2';
import { CreateCustomerProfileV2 } from './pages/customer-profiles/CreateCustomerProfileV2';
import { CreateSupplierProfileV2 } from './pages/supplier-profiles/CreateSupplierProfileV2';
import DocumentDetails from './pages/document-details/DocumentDetails';
import LibraryItemDetails from './pages/library-item-details/LibraryItemDetails';
import { useAuth } from '@clerk/clerk-react';
import EmployeeProfilePageForAdmin from './pages/employee-profiles/EmployeeProfilePageForAdmin';
import HomePage from './pages/home/HomePage';
import Library from './pages/library-v2/Library';
import LogIn from './pages/login/LogIn';
import SignUp from './pages/signup/SignUp';

const App = () => {
  const { isSignedIn } = useAuth();
  useUserInfo().catch();
  useCountriesInfo();
  return (
    <Routes>
      <Route path='*' element={<PageNotFound />} />
      <Route
        path={ROUTES.INDEX}
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route
          path={ROUTES.BUSINESS_PROFILE}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <BusinessProfile />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.SIGNING_DOCUMENT}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <SigningPage />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.DOCUMENTS}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <DocumentsPage />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.DOCUMENT_VAULT}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <DocumentVault />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.DOCUMENT_VAULT_CATEGORY_DOCUMENT}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <DocumentDetails />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        {/*<Route
          path={ROUTES.WORKSPACE_DOCUMENT}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <DocumentDetails />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />*/}
        <Route
          path={ROUTES.PRICING}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <PricingPage />
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PRODUCT_PLAN_CONFIRMATION}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <PlanConfirmation />
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.HOME}
          element={
            <ProtectedRoute>
              <HomePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.EMPLOYEE_PROFILES}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <EmployeeProfilesV2 />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.EMPLOYEE_PROFILE}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <EmployeeProfileV2 />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.EMPLOYEE_PROFILE_CREATE}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <EmployeeProfilePageForAdmin />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.SUPPLIER_PROFILES_V2}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <SupplierProfilesV2 />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.SUPPLIER_PROFILES}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <SupplierProfilesV2 />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.SUPPLIER_PROFILE_CREATE}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <CreateSupplierProfileV2 />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.SUPPLIER_PROFILE}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <SupplierProfileV2 />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.CUSTOMER_PROFILES}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <CustomerProfilesV2 />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.CUSTOMER_PROFILE_CREATE}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <CreateCustomerProfileV2 />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.CUSTOMER_PROFILE}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <CustomerProfileV2 />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.DOCUMENT_LIBRARY}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <Library />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        {/*<Route
          path={ROUTES.WORKSPACE}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <Workspace />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />*/}
        <Route
          path={ROUTES.TEMPLATE_ITEM}
          element={
            <ProtectedRoute>
              <RolesGateRedirect group={GROUPS.COMPANY_ADMIN}>
                <NoCompanyRedirect>
                  <LibraryItemDetails />
                </NoCompanyRedirect>
              </RolesGateRedirect>
            </ProtectedRoute>
          }
        />
        <Route path={ROUTES.ACCEPTED_INVITE} element={<SignUp />} />
        <Route path={ROUTES.EMAIL_SENT} element={<EmailSent />} />
        <Route path={ROUTES.PROCESS_SUCCESS} element={<ProcessSuccess text={'Confirmed.'} />} />
        <Route
          path={ROUTES.SETTINGS}
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
        <Route path={ROUTES.CONFIRMATION} element={<Confirmation />} />
      </Route>
      <Route path={ROUTES.JOIN_COMPANY} element={<PassConfirmation />} />
      {/*<Route path={ROUTES.PASSWORD_RESET} element={<PasswordResetV2 />} />*/}
      <Route
        path={ROUTES.LOGIN}
        element={
          isSignedIn ? (
            <Navigate to={ROUTES.INDEX} />
          ) : (
            <ClerkSignedOut>
              <LogIn />
            </ClerkSignedOut>
          )
        }
      />
      <Route
        path={ROUTES.SIGN_UP}
        element={
          <ClerkSignedOut>
            <SignUp />
          </ClerkSignedOut>
        }
      />
      {/*<Route path={ROUTES.ACCEPTED_INVITE} element={<ProcessSuccess text={'Accepted'} />} />*/}
      <Route
        path={ROUTES.COMPANY_CREATE}
        element={
          <NoCompanyHandler>
            <CompanyCreate />
          </NoCompanyHandler>
        }
      />
    </Routes>
  );
};

export default App;
